import { createEntityAdapter } from '@reduxjs/toolkit';
import { IEppTerminalEdit } from 'application/editcomp/api/EppTerminal';

export const eppTerminalEditAdapter = createEntityAdapter<IEppTerminalEdit, number>({
  selectId: (project) => project.eppTerminalID,
  sortComparer: (a, b) => a.name.localeCompare(b.name),
});
